// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Friends, Player, Game } = initSchema(schema);

export {
  Friends,
  Player,
  Game
};